import React from 'react'
import TextImageCTA from '../sections/text-image-cta'

const TextImageCTASlice = ({ slice }) => {
  const {
    text_image_cta_text,
    text_image_cta_link,
    text_image_cta_link_text,
    text_image_cta_link_arrow_type,
    text_image_cta_link_arrow_position,
    text_image_cta_image,
    text_image_cta_margin_bottom,
    text_image_cta_container_fluid,
    text_image_cta_text_color,
    text_image_cta_background_color,
  } = slice.primary

  return (
    <TextImageCTA
      text={ text_image_cta_text }
      link={ text_image_cta_link.url }
      linkText={ text_image_cta_link_text }
      linkExternal={ text_image_cta_link.type === 'Web' }
      linkNewTab={ text_image_cta_link.target === '_blank' }
      linkArrowType={ text_image_cta_link_arrow_type }
      linkArrowPosition={ text_image_cta_link_arrow_position }
      image={ text_image_cta_image.fluid }
      imageAlt={ text_image_cta_image.alt }
      marginBottom={ text_image_cta_margin_bottom }
      containerFluid={ text_image_cta_container_fluid }
      textColor={ text_image_cta_text_color }
      backgroundColor={ text_image_cta_background_color }
    />
  )
}

export default TextImageCTASlice